import { Reorder } from 'framer-motion'

const ulStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  width: '100%'
}

export const DraggableListServicePriority = ({ data: items, onUpdate }) => (
  <Reorder.Group style={ulStyle} axis="y" values={items} onReorder={onUpdate}>
    {items.map((item, index) => (
      <Reorder.Item
        style={{ listStyle: 'none' }}
        key={item.id}
        value={item}
        className="community-drag-item"
      >
        <span className="community-drag-item__handle">⠿</span>
        <span className="community-drag-item__label">{item.id}</span>
        <span className="nbadge">{index + 1}</span>
      </Reorder.Item>
    ))}
  </Reorder.Group>
)
